import classNames from 'classnames/bind';
import React, { useId } from 'react';

import { WarningNotifRed } from '../../assets/icons/Icons';
import Styles from './TextArea.module.scss';

const cx = classNames.bind(Styles);

interface Props extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  errorMessage?: string;
  label?: React.ReactNode | string;
  error?: boolean;
  'aria-label'?: string;
  className?: string;
}

const TextArea = React.forwardRef<HTMLTextAreaElement, Props>(
  (
    {
      label,
      disabled = false,
      rows = 6,
      id,
      error,
      errorMessage,
      placeholder = 'Type Something...',
      className,
      ...otherProps
    }: Props,
    ref,
  ) => {
    const elementId = id || useId();

    return (
      <div className={cx('form-element', 'container', className)} data-testid='free-text'>
        <div className={cx({ 'label-wrapper': label, 'sr-only': !label })}>
          <label htmlFor={elementId} className={cx({ label: label, 'label--disabled': label && disabled })}>
            {label}
          </label>
        </div>
        <textarea
          ref={ref}
          disabled={disabled}
          className={cx('freetext', { 'freetext--error': error })}
          id={elementId}
          rows={rows}
          placeholder={placeholder}
          {...otherProps}></textarea>
        {error ? (
          <p className={cx('error-message')}>
            {WarningNotifRed}
            {errorMessage}
          </p>
        ) : null}
      </div>
    );
  },
);

TextArea.displayName = 'TextArea';

export default TextArea;
